import { useEffect, useState } from "react";
import Button from "../../../../../button/button";
import InputAnimated from "../../../../../inputAnimated/inputAnimated";
import Modal from "../../../../../modal/modal";
import Select from "../../../../../select/select";
import DropDownList from "../../../../../Dropdown/DropDownList";
import { PatchRefundReceipt } from "../../../../../../utils/Apis/receptionApis";
import { dataDecrypt } from "../../../../../../utils/dataDecrypt";
import { dataEncrpt } from "../../../../../../utils/dataEncrypt";
import Alert from "../../../../../alert/Alert";
import { getWeekRange } from "../../../../../../utils/dateUtils";
/**
 * Componente para realizar reembolsos de un recibo.
 * Permite:
 *  - Reembolso total
 *  - Reembolso parcial por concepto (agrupado por alumno)
 */
const PaymentRefund = ({ isOpen, onClose, receiptData, employee_id, setLoading, refreshPaymentHistory, studentId, index }) => {

    const [concetpDataState, setConceptDataState] = useState(null)
    const [refundAmount, setRefundAmount] = useState(0);
    const [specificRefundAmount, setSpecificRefundAmount] = useState(0);
    const [receiptId, setReceiptId] = useState('');
    const [disableInputRefund, setDisabledInputRefund] = useState(true)
    const [disableButton, setDisableButton] = useState(false);
    ////Alert
    const [isVisibleAlert, setIsVisibleAlert] = useState(false);
    const [arrayAlerts, setArrayAlerts] = useState([])
    /**
     * Tipo de reembolso seleccionado:
     *  - ''        -> ninguno
     *  - 'total'   -> reembolso completo
     *  - 'partial' -> reembolso por conceptos
     */
    const [refundType, setRefundType] = useState('');

    /**
     * Lista de conceptos seleccionados para reembolso parcial.
     * Se guardan como IDs únicos (studentId-detailId)
     * Ej: "128-635-1"
     */
    const [selectedConcepts, setSelectedConcepts] = useState([]);

    /**
     * Opciones del selector de tipo de reembolso
     */
    const refundOptions = [
        { value: "total", label: "Total" },
        { value: "partial", label: "Parcial" },
        { value: "specific", label: "Especifico" }
    ];

    /**
     * Estructura de datos para DropDownList
     * Se agrupa por alumno y cada concepto tiene:
     *  - Un checkbox controlado por estado
     *  - Un ID único para evitar colisiones entre alumnos
     */
    useEffect(() => {
        if (isOpen) {
            setRefundType('');
            setReceiptId(receiptData.id);
            setSelectedConcepts([]);
            setSpecificRefundAmount(0);
            setRefundAmount(0);
        }
    }, [isOpen, receiptData]);
    useEffect(() => {
        if (!isOpen) return;

        const conceptsData = receiptData.students.map(student => ({
            studentId: student.id,
            studentName: student.name,
            details: student.payment_detail.map(detail => ({
                id: detail.id,
                concept: detail.concept.name,
                amount: detail.amount,
                paidWeeks: detail.paidWeeks
            }))
        }));
        setConceptDataState(conceptsData);
    }, [isOpen, receiptData]);

    

    const dropdownData = concetpDataState?.map(student => ({
        name: student.studentName,
        link: '#',
        status: 'active',
        children: student.details.map((detail, i) => {
            const uniqueKey = `${student.studentId}-${detail.id}`;

            if (detail.concept !== "Colegiatura") {
                return {
                    name: (
                        <div
                            data-id={uniqueKey}
                            data-amount={detail.amount}
                            student-id={student.studentId}
                            concept={detail.concept}
                            style={{ display: 'flex', alignItems: 'center', gap: 8 }}
                            onClick={() => handleToggle({
                                props: {
                                    'data-id': uniqueKey,
                                    'data-amount': detail.amount,
                                    'student-id': student.studentId,
                                    'concept': detail.concept,
                                    'date-type': 'single'
                                }
                            })}
                        >
                            <input
                                type="checkbox"
                                checked={selectedConcepts.some(c => c.id === uniqueKey)}
                                readOnly
                            />
                            <span>{detail.concept} ${detail.amount}</span>
                        </div>
                    )
                };
            }

            // 🔥 CASO COLEGIATURA
            const sortedWeeks = [...detail.paidWeeks]
                .map(w => ({ ...w, weekNumber: parseInt(w.number) }))
                .sort((a, b) => b.weekNumber - a.weekNumber); // orden descendente


            return {
                name: detail.concept,
                link: '#',
                status: 'active',
                children: [
                    // 🔹 Todas las semanas
                    {
                        name: (
                            <div
                                data-id={`${uniqueKey}-${i}`}
                                date-type="all-weeks"
                                data-amount={detail.amount}
                                student-id={student.studentId}
                                concept={detail.concept}
                                onClick={() => handleToggle({
                                    props: {
                                        'data-id': `${uniqueKey}-${i}`,
                                        'data-amount': detail.amount,
                                        'student-id': student.studentId,
                                        'concept': detail.concept,
                                        'date-type': 'all-weeks'
                                    }
                                })}
                            >
                                <input
                                    type="checkbox"
                                    checked={selectedConcepts.some(c => c.id === `${uniqueKey}-${i}`)}
                                    readOnly
                                />
                                <span>Todas las semanas</span>
                            </div>
                        ),
                        link: '#',
                        status: 'active'
                    },

                    // 🔹 Semanas individuales
                    ...sortedWeeks.map(week => {
                        const weekKey = `${uniqueKey}-${i}-${week.number}-${week.year}`;

                        const selectedWeeksByStudent = selectedConcepts
                            .filter(c =>
                                c.student_id === student.studentId &&
                                c.concept === "Colegiatura" &&
                                c.colegiaturaDateType === 'week'
                            )
                            .map(c => parseInt(c.id.split('-').slice(-2)[0])); // obtiene week.number

                        const lastWeekNumber = sortedWeeks[0]?.weekNumber;

                        const lowestSelected = selectedWeeksByStudent.length
                            ? Math.min(...selectedWeeksByStudent)
                            : null;

                        const isDisabled = lowestSelected
                            ? (
                                week.weekNumber !== lowestSelected - 1 &&
                                !selectedWeeksByStudent.includes(week.weekNumber)
                            )
                            : (
                                week.weekNumber !== lastWeekNumber
                            );
                        return {
                            name: (
                                <div
                                    data-id={weekKey}
                                    date-selected={week}
                                    data-amount={week.amount}
                                    student-id={student.studentId}
                                    concept={detail.concept}
                                    date-type="week"
                                    onClick={() => handleToggle({
                                        props: {
                                            'data-id': weekKey,
                                            'data-amount': week.amount,
                                            'student-id': student.studentId,
                                            'concept': detail.concept,
                                            'date-type': 'week',
                                            'date-selected': week
                                        }
                                    })}
                                >
                                    <input
                                        type="checkbox"
                                        checked={selectedConcepts.some(c => c.id === weekKey)}
                                        readOnly
                                        disabled={isDisabled}
                                    />
                                    <span>Semana {getWeekRange(week.number, week.year)}</span>
                                </div>
                            ),
                            link: '#',
                            status: isDisabled ? 'disabled' : 'active'
                        };
                    })
                ]
            };
        })
    }));

    useEffect(() => {
        if (!isOpen || !refundType) return;

        if (refundType === 'total') {
            setDisabledInputRefund(true)
            setRefundAmount(receiptData.total_amount);
            setSelectedConcepts([]);
        }
        if (refundType === 'specific') {
            setRefundAmount(receiptData.total_amount);
            setDisabledInputRefund(false)
            setSelectedConcepts([]);
        }
    }, [isOpen, refundType]);

    useEffect(() => {
        if (!isOpen || refundType !== 'partial') return;
        setDisabledInputRefund(true)

        const totalSelected = selectedConcepts.reduce(
            (total, item) => total + item.amount,
            0
        );

        setRefundAmount(totalSelected);
    }, [isOpen, refundType, selectedConcepts]);



    /**
     * Maneja el click sobre un item del DropDownList
     * El dropdown no permite interactuar directamente con el checkbox,
     * así que el toggle se maneja desde aquí
     */
    const handleToggle = (item) => {
        if (item?.status === "disabled") {
            return;
        }

        if (item?.link && item.link !== "#") {
            window.open(item.link, "_blank", "noopener,noreferrer");
            return;
        }

        const element = item?.props ? item : item?.name;
        const id = element?.props?.['data-id'];
        const amount = Number(element?.props?.['data-amount']);
        const student_id = Number(element?.props?.['student-id']);
        const concept = element?.props?.['concept'];
        const dateSelected = element?.props?.['date-selected'] || {};
        const colegiaturaDateType = element?.props?.['date-type'] || '';

        if (!id) return;

        setSelectedConcepts(prev => {
            const exists = prev.find(c => c.id === id);

            // 🔥 VALIDACIÓN DE BLOQUEO (ANTES DE REMOVER)
            if (exists && concept === "Colegiatura" && colegiaturaDateType === 'week') {

                const weeks = prev
                    .filter(c =>
                        c.student_id === student_id &&
                        c.colegiaturaDateType === 'week'
                    )
                    .map(c => c.dateSelected.weekNumber); // 👈 mejor que parsear id

                const lowest = Math.min(...weeks);
                const currentWeek = dateSelected.weekNumber;

                // ❌ no permitir desmarcar si no es la última
                if (currentWeek !== lowest) {
                    return prev;
                }

                // ✅ ahora sí se puede quitar
                return prev.filter(c => c.id !== id);
            }

            // 🔹 Toggle OFF normal (para otros casos)
            if (exists) {
                return prev.filter(c => c.id !== id);
            }

            let newSelection = [...prev, {
                id,
                amount,
                student_id,
                concept,
                dateSelected,
                colegiaturaDateType
            }];

            if (concept === "Colegiatura") {

                // 🔹 TODAS LAS SEMANAS → limpia weeks del mismo alumno
                if (colegiaturaDateType === 'all-weeks') {
                    newSelection = newSelection.filter(c =>
                        !(
                            c.student_id === student_id &&
                            c.concept === "Colegiatura" &&
                            c.colegiaturaDateType === 'week'
                        )
                    );
                }

                // 🔹 WEEK → quita "all-weeks"
                if (colegiaturaDateType === 'week') {
                    newSelection = newSelection.filter(c =>
                        !(
                            c.student_id === student_id &&
                            c.concept === "Colegiatura" &&
                            c.colegiaturaDateType === 'all-weeks'
                        )
                    );
                }
            }

            return newSelection;
        });
    };
    /**
     * Efecto solo para debug
     * Muestra siempre el estado actualizado de los conceptos seleccionados
     */

    const handleConfirmRefund = async () => {
        setDisableButton(true)
        if (!refundType) { setDisableButton(false); return showAlert('danger', 'Selecciona tipo de reembolso') }
        if (refundType === 'partial' && selectedConcepts.length === 0) { setDisableButton(false); return showAlert('danger', 'Selecciona los conceptos que desea reembolsar') }
        if (refundType === 'specific' && (specificRefundAmount === '' || specificRefundAmount === '0' || specificRefundAmount <= 0 || specificRefundAmount === null || specificRefundAmount === undefined)) { setDisableButton(false); return showAlert('danger', 'Ingresa el monto a reembolsar') }
        if (refundType === 'specific' && (parseFloat(specificRefundAmount) >= parseFloat(refundAmount))) { setDisableButton(false); return showAlert('danger', 'Asegurese que el monto a reembolsar no sea igual o mayor al monto total del recibo') }
        const refundReceiptPetition = await PatchRefundReceipt(receiptId, refundType, selectedConcepts, employee_id, specificRefundAmount)
        if (refundReceiptPetition.status === 200) {
            const totalAmountAlarm = dataDecrypt(localStorage.getItem('alarmToCashAudit'))
            const newAmountForAlarm = totalAmountAlarm - refundReceiptPetition.amount_refunded
            showAlert('success', refundReceiptPetition.message)
            localStorage.setItem(
                'alarmToCashAudit',
                dataEncrpt(newAmountForAlarm)
            );
            setLoading(true)
            setTimeout(async () => {
                await refreshPaymentHistory(studentId, index)
                setLoading(false)
            }, 500);
            setDisableButton(false)
            onClose();
        } else {
            setDisableButton(false)
            showAlert('danger', refundReceiptPetition.message)
            setLoading(false)

        }

    }

    const showAlert = (type, message) => {
        const id = Math.floor(Math.random() * 100) + 1;
        const alertObj = { id, type, message };

        setArrayAlerts(oldArray => [alertObj, ...oldArray]);
        setIsVisibleAlert(true);
    };
    return (
        <>

            <Modal isOpen={isOpen} onClose={onClose} overlayClick={false}>
                <div className="change-receipt-pmethod-container">

                    <h1 className="title-1">Realizar reembolso en efectivo</h1>

                    {/* Folio solo informativo */}
                    <InputAnimated value={receiptId} placeholder="Folio" disabled />

                    {/* Selector de tipo de reembolso */}
                    <Select
                        options={refundOptions}
                        placeholder="Selecciona tipo de reembolso"
                        onChange={(e) => setRefundType(e.target.value)}
                        value={refundType}
                    />

                    {/* Reembolso parcial: selección por conceptos */}
                    {refundType === 'partial' && (
                        <DropDownList
                            Data={dropdownData}
                            iconColor="red"
                            onMenuItemClick={handleToggle}
                        />
                    )}

                    {/* Importe manual (puede automatizarse después) */}
                    <InputAnimated placeholder="Importe a reembolsar" value={disableInputRefund ? refundAmount : specificRefundAmount} onChange={(e) => {
                        const clean = e.target.value.replace(/[^0-9.]/g, '');
                        setSpecificRefundAmount(clean);
                    }} disabled={disableInputRefund} />

                    <div className="confirm-buttons-section">
                        <Button
                            text="Cancelar"
                            backgroundColor="red"
                            onClick={onClose}
                        />
                        <Button text="Confirmar" onClick={handleConfirmRefund} disabled={disableButton} />
                    </div>

                </div>
                <div className="divAlert">
                    <Alert arrayAlertsModule={arrayAlerts} setArrayAlertsModule={setArrayAlerts} isVisibleModule={isVisibleAlert} setIsVisibleModule={setIsVisibleAlert} />
                </div>
            </Modal>
        </>
    );
};

export default PaymentRefund;
